<template>
  <modal size="xl" @close="$emit('close')">
    <form class="w-full mb-4" @submit.prevent="submit">
      <div class="mb-2">
        <nx-input
          v-model="data.name"
          :errors="form.errors"
          label="Title"
          id="title"
          placeholder="Channel Name"
          maxlength="50"
          :focus="true"
        />
      </div>

      <div class="mb-2">
        <nx-richtextarea
          v-model="data.description"
          :errors="form.errors"
          label="Description"
          :simple="true"
          :include-emotes="true"
          placeholder="Channel Description…"
          id="description"
        />
      </div>

      <div class="mb-2">
        <nx-select
          id="category"
          v-model="data.channel_category"
          :options="categories"
          track-by="slug"
          option-label="name"
          :errors="form.errors"
          label="Category"
        ></nx-select>
      </div>

      <div class="mb-2">
        <nx-select
          id="moderators"
          v-model="data.moderators"
          :options="moderators"
          :multiple="true"
          :errors="form.errors"
          label="Moderators"
        ></nx-select>
      </div>

      <div class="mb-2">
        <label for="locked" class="inline-flex items-center">
          <input
            type="checkbox"
            class="form-checkbox text-blue-5"
            v-model="data.locked"
            id="locked"
          />
          <span class="ml-2">Locked</span>
        </label>
      </div>

      <div class="w-full">
        <nx-button
          native-type="submit"
          type="primary"
          :disabled="loading"
        >{{ loading ? 'Loading..' : 'Submit' }}</nx-button>
      </div>
    </form>
  </modal>
</template>

<script>
import Form from "form-backend-validation"
import { map } from "lodash"
import { mapGetters } from "vuex"

export default {
  name: "ChannelUpdateForm",
  props: {
    existing: {
      required: true
    },
    category: {
      required: true
    }
  },
  data() {
    return {
      form: new Form(),
      loading: false,
      data: {
        name: "",
        description: "",
        channel_category: "",
        moderators: [],
        locked: false
      },
      moderators: []
    }
  },
  computed: {
    ...mapGetters({
      categories: "categories/list"
    })
  },
  methods: {
    async fetch() {
      this.loading = true
      await this.$api.users
        .get(this.page, "moderator")
        .then(
          ({ data }) => (this.moderators = map(data, item => item.username))
        )
      this.loading = false
    },
    submit() {
      let data = this.data
      data.channel_category = data.channel_category.slug
      this.$api.channels
        .update(this.category.slug, this.existing.slug, data)
        .then(() => {
          this.$toasted.success('Channel updated.')
          this.$emit("success")
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          }else{
            this.$error.generic()
          }
        })
    }
  },
  created() {
    this.data = {
      name: this.existing.name,
      description: this.existing.description,
      moderators: this.existing.moderators,
      locked: this.existing.locked,
      channel_category: this.category
    }
  },
  mounted() {
    this.fetch()
  }
}
</script>
